import { ROTA_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useRotaOverbookingRequestDeleteAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (requestId: string): Promise<boolean> => {
      dispatch(setLoading({ key: "isOverbookingRequestMutationInProgress", status: true }));
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse = await axios.delete(
          `${ROTA_APIS?.ROTA_OVERBOOKING_REQUESTS?.baseURL ?? ""}${requestId}/`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res.status === 204 || res.data?.status === true) {
          toast.success("Overbooking request deleted");
          return true;
        }

        toast.error("Unable to delete overbooking request");
        return false;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          sendCurl?.(error.config?.["curlCommand"]);
          captureError(error);
        } else {
          toast.error("Server Error: " + (error as Error).message);
        }
        return false;
      } finally {
        dispatch(setLoading({ key: "isOverbookingRequestMutationInProgress", status: false }));
      }
    },
    [captureError, configuration, dispatch, sendCurl],
  );

  return execute;
};

// Backward-compatible alias
export const useRotaOverBookingDeletionApi = useRotaOverbookingRequestDeleteAPI;
